import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import Seo from './Seo';

/** Redirect with noindex so Google does not treat hash/duplicate URLs as thin pages. */
function NoindexRedirect({ to, path }) {
	const location = useLocation();
	const canonicalPath = path || location.pathname;

	return (
		<>
			<Seo noindex path={canonicalPath} title="Redirect" description="" />
			<Redirect to={to} />
		</>
	);
}

export default NoindexRedirect;
